import React from 'react';
import './RadiusExpansionPrompt.css';

/**
 * Component to prompt users to expand their job search radius
 * Shows when no more jobs are available in current radius
 */
const RadiusExpansionPrompt = ({ 
    currentRadius, 
    nextRadius, 
    onExpand, 
    onDecline, 
    isExpanding = false 
}) => {
    return (
        <div className="radius-expansion-card">
            <div className="radius-expansion-content">
                {/* Title */}
                <h3 className="radius-expansion-title">
                    No more jobs within {currentRadius}km radius
                </h3>

                {/* Message */}
                {nextRadius ? (
                    <p className="radius-expansion-message">
                        Would you like to expand your search radius to find more opportunities?
                    </p>
                ) : (
                    <p className="radius-expansion-message">
                        You've reached the maximum search distance ({currentRadius}km).
                        <br />
                        No more jobs available in your area.
                    </p>
                )}

                {/* Buttons */}
                {nextRadius ? (
                    <div className="radius-expansion-buttons">
                        <button
                            onClick={onDecline}
                            disabled={isExpanding}
                            className="radius-expansion-btn radius-expansion-btn-decline"
                        >
                            No, Thanks
                        </button>
                        <button
                            onClick={onExpand}
                            disabled={isExpanding}
                            className="radius-expansion-btn radius-expansion-btn-expand"
                        >
                            {isExpanding ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    <span style={{ marginLeft: '0.5rem' }}>Expanding...</span>
                                </>
                            ) : (
                                <>
                                    Yes, Expand
                                </>
                            )}
                        </button>
                    </div>
                ) : (
                    <div className="radius-expansion-max-reached">
                        <i className="fas fa-info-circle"></i>
                        <span>Maximum search distance reached</span>
                    </div>
                )}
            </div>
        </div>
    );
};

/**
 * Simple message component when user declines expansion
 */
export const NoMoreJobsMessage = ({ currentRadius }) => {
    return (
        <div className="no-more-jobs-card">
            <div className="no-more-jobs-content">
                <i className="fas fa-check-circle no-more-jobs-icon"></i>
                <h4 className="no-more-jobs-title">No more jobs available</h4>
                <p className="no-more-jobs-message">
                    You've seen all jobs within radius
                </p>
            </div>
        </div>
    );
};

export default RadiusExpansionPrompt;
